import request from "../utils/request";

export function getIdentifyInfo(aiType, data) {
  return request({
    url: `/index/${aiType}/get_material_identify_info`,
    method: "get",
    params: data,
  });
}

export function identify(aiType, data) {
  return request({
    url: `/index/${aiType}/identify`,
    method: "post",
    data: data,
  });
}
